import { createAsyncThunk } from "@reduxjs/toolkit";
import { type CoverageZone } from "../../../domain/entities/coverage";
import { type ZonesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listCoverage = createAsyncThunk<
  CoverageZone[],
  string,
  { dispatch: ZonesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_COVERAGE, async (countryCode, { extra }) => {
  return await extra.zonesRepo.listCoverage(countryCode);
});
